import { Box, Grid, TextField } from '@mui/material'
import React from 'react'
import { PickingDiffFilter } from '../../../interfaces/PickingValidate/PickingDiffFilter'

interface PickingDiffSearchProps {
  filters: PickingDiffFilter
  handleOnChangeFilter: (e: any) => void
}

export const PickingDiffSearch: React.FC<PickingDiffSearchProps> = ({
  filters,
  handleOnChangeFilter
}) => {
  return (
    <Grid container direction='row' spacing={2}>
      <Grid item xs={12} sm={6} lg={6}>
        <Box component='form'>
          <TextField
            id='positionName'
            name='positionName'
            label='Buscar Posición'
            onChange={handleOnChangeFilter}
            autoComplete='off'
            value={filters.positionName}
          />
        </Box>
      </Grid>
    </Grid>
  )
}
